<div class="video-player-container">
  <video
    #videoRef
    (ended)="onEnded($event)"
    (loadedmetadata)="onLoadedMetadata($event)"
    (pause)="onPause($event)"
    (play)="onPlay($event)"
    (timeupdate)="onTimeUpdate($event)"
    [autoplay]="autoplay"
    [loop]="loop"
    [muted]="isVideoMuted()"
    [src]="src"
    class="slide-video"
  ></video>

  <!-- Touch overlay for mobile touch detection -->
  <div
      (touchend)="onVideoTouchEnd($event)"
      (touchstart)="onVideoTouchStart($event)"
      class="video-touch-overlay"
  ></div>

  <app-video-controls
      (controlsTouch)="onControlsTouch()"
      (progressClick)="onProgressClick($event)"
      (toggleMute)="toggleMute()"
      (togglePlayPause)="togglePlayPause()"
      (volumeChange)="onVolumeChange($event)"
      [currentTime]="formatTime(videoCurrentTime())"
      [duration]="formatTime(videoDuration())"
      [isMuted]="isVideoMuted()"
      [isPaused]="isVideoPaused()"
      [mobileVisible]="mobileControlsVisible"
      [progressPercentage]="progressPercentage"
      [visible]="controlsVisible"
      [volume]="videoVolume()"
  ></app-video-controls>
</div>
